import React from "react";
import Helmet from "react-helmet";
import { Button } from "../../genericComponents";
import styled from "styled-components";
import avatarImage from "../../../assets/images/sprites/avatar-person.svg";
import { ThemeProps } from "../../genericComponents/globalStyles";


export default function ProfileInfo({ userProfile, image }) {

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`${userProfile.name}`}</title>
      </Helmet>
      <EditContainer>
        {/* <PDFDownloadLink document={<CVDocument
          userProfile={userProfile}
          workExperiences={userWorks}
          educations={userSchools}
          volunteers={userVolunteers}
          researches={userResearchs} />} fileName={`${userProfile.name}_resume.pdf`}>
          {({ blob, url, loading, error }) => loading ? (null) : (<BackgroundColorButton
            backgroundColor={ThemeProps.color.gabaYellow}>{'Generate CV'}</BackgroundColorButton>)}
        </PDFDownloadLink> */}
      </EditContainer>
      <DataProfileContainer>
        <ImageContainer>
          {image ? (
            <ImgProfile alt="user" src={image} />
          ) : (
              <ImgProfile alt="user" src={avatarImage} />
            )}
        </ImageContainer>
        <div>
          <NameTitle>
            {`${userProfile.name}`}
            <TitleSubIndex>
              {userProfile.pronouns}
            </TitleSubIndex>
          </NameTitle>
          {userProfile.medical_school.length > 0 && (
            <SubTitle>{userProfile.medical_school}</SubTitle>
          )}
          <UlTags>
            {userProfile?.specialties.length > 0 && (
              <LiTags>
                <ATags>{userProfile?.specialties.join(" ")}</ATags>
              </LiTags>
            )}
            <LiTags>
              <ATags>{userProfile.class_status} Student</ATags>
            </LiTags>
            {userProfile.honors?.length > 0 &&
              userProfile.honors.map((item, index) => (
                <LiTags key={index}>
                  <ATags>{item}</ATags>
                </LiTags>
              ))}
          </UlTags>
        </div>
      </DataProfileContainer>
      {
        userProfile.about && (
          <AboutContainer>
            <Text fontSize={'2.1'}>Bio</Text>
            <Text fontSize={'1.3'}>{userProfile.about || "Describe about yourself"}</Text>
          </AboutContainer>
        )
      }
    </>
  );
}

const AboutContainer = styled.div`
  padding: 8px 0;
  margin-top: 24px;
  margin-right: 24px;
  border-radius: 8px;
  background-color: ${ThemeProps.color.softYellow};
`;
const Text = styled.p`
  font-size: ${p => p.fontSize}em;
  margin: 8px 16px;
`;
const BackgroundColorButton = styled(Button)`
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.theme.color.goodNightColor};
  padding: 10px 14px 14px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  min-width: 120px;
  margin-bottom: -32px;
`;
const UlTags = styled.ul`
  list-style: none;
`;
const LiTags = styled.li`
  margin-top: 4px;
  margin-right: 12px;
  display: inline-block;
  vertical-align: middle;
  padding: 8px 16px;
  border-radius: 6px;
  background: rgba(114, 128, 219, 0.22);
  cursor: default;
`;
const ATags = styled.p`
  color: ${(props) => props.theme.color.darkBlue};
  font-size: 1.1em;
  font-weight: bold;
`;
const NameTitle = styled.p`
  font-size: 3.5em;
  margin-bottom: 0;
`;
const TitleSubIndex = styled.sub`
  font-size: 0.5em;
  margin-top: -32px;
  bottom: 1em;
`;
const SubTitle = styled.p`
  font-size: 1.9em;
  margin-bottom: 12px;
`;
const ImageContainer = styled.div`
  width: 140px;
  height: 140px;
  margin-right: 16px;
`;
const DataProfileContainer = styled.div`
  margin-top: 24px;
  display: flex;
`;
const ImgProfile = styled.img`
  width: 140px;
  height: 140px;
  border-radius: 140px;
`;
const EditContainer = styled.div`
  padding: 0 24px;
  display: flex;
  justify-content: flex-end;
`;
const EditButton = styled.button`
  background: none;
  border: none;
  padding: 4px;
  /* outline: none; */
`;
